module.exports = __webpack_public_path__ + "static/media/Beach Sun Birds.be758415.svg";